module.exports = __webpack_public_path__ + "static/media/sms.c33e578b.svg";